export default __webpack_public_path__ + "static/media/Quiz-o-quest.88124aaf.jpg";